import { CheckBoxGroupProps } from "./types"
import React from "react"
import { CheckBox } from "~widgets/check-box"
import { FeildFloatLabel } from "~widgets/feild-float-label"
import styled from '~/ui/styled'

const CheckBoxGroupWrapper = styled.View``

const CheckBoxesArea = styled.View`
  flex-direction: row;
`

const CheckBoxWrapper = styled.View`
  margin-right: 15px;
`

const CheckBoxGroup: React.FC<CheckBoxGroupProps> = ({ label, options, value, setValue }) => {
  return (
    <CheckBoxGroupWrapper>
      {!!label && <FeildFloatLabel>{label}</FeildFloatLabel>}
      <CheckBoxesArea>
        {options.map((option) => {
          return (
            <CheckBoxWrapper key={option.value}>
              <CheckBox {...option} curValue={value} onClick={setValue} />
            </CheckBoxWrapper>
          )
        })}
      </CheckBoxesArea>
    </CheckBoxGroupWrapper>
  )
}

export default CheckBoxGroup
